module.exports = __webpack_public_path__ + "static/media/invoice_coupon_help_v2.2dcbeb2b.png";